import { useState } from "react";
import { missingBeforeSend } from "@/lib/offer-status-patch";
import type { Offer, OfferStatus } from "@/hooks/use-offers";

/**
 * Statusendring fra tilbudsheaderen, med dialogene som må komme først når
 * pipelinen er på. Flyttet ut av OfferEditPage (VIB-2979) uten endret oppførsel.
 *
 * VIB-1304 (Erik 15.07): status->lost åpner ALLTID LostReasonDialog først
 * når pipelinen er på — handleStatusChange no-op-er for "lost" i det
 * tilfellet (se use-offer-page-handlers.ts), så committing skjer kun via
 * handleConfirmLost etter bekreftelse. Avbryt = ingen statusendring.
 *
 * VIB-2094 (Erik 28.09): samme mønster for sending — mangler sannsynlighet
 * eller estimert close-dato, åpner vi SendOfferDialog i stedet for å endre
 * status. Avbryt = tilbudet forblir utkast.
 */
export function useOfferStatusRequest({
  offer,
  pipelineEnabled,
  onStatusChange,
}: {
  offer: Offer | null | undefined;
  pipelineEnabled: boolean;
  onStatusChange: (status: OfferStatus) => void;
}) {
  const [lostReasonDialogOpen, setLostReasonDialogOpen] = useState(false);
  const [sendDialogOpen, setSendDialogOpen] = useState(false);

  function requestStatusChange(status: OfferStatus) {
    if (pipelineEnabled && status === "lost") {
      setLostReasonDialogOpen(true);
      return;
    }
    if (pipelineEnabled && status === "sent" && offer && missingBeforeSend(offer)) {
      setSendDialogOpen(true);
      return;
    }
    onStatusChange(status);
  }

  return {
    lostReasonDialogOpen,
    setLostReasonDialogOpen,
    sendDialogOpen,
    setSendDialogOpen,
    requestStatusChange,
  };
}
